import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Report, RowActions } from 'src/app/dashboard/admin/report/report';
import { BaseBillReportComponent } from '../../baseBillReport.component';
import { BillServiceDeleteService } from '../services/bill-service-delete.service';
import { BillServiceReportService } from '../services/bill-service-report.service';
import { BillerDeleteBillerServiceService } from '../services/biller-delete-biller-service.service';

@Component({
  selector: 'app-bill-service-list',
  templateUrl: './bill-service-list.component.html',
  styleUrls: ['./bill-service-list.component.scss'],
})
export class BillServiceListComponent
  extends BaseBillReportComponent
  implements OnInit
{
  displayTableColumns: { [key: string]: string } = {
    name: 'Name',
    image: 'image',
    provider: 'Provider',
    category: 'Category',
    billerService: 'Biller',
    createdAt: 'Created At',
    cashBack: 'Cash Back'
  };
  properties = [
    'name',
    'image',
    'provider',
    'category',
    'billerService',
    'cashBack',
    'createdAt'
  ];
  data;

  columnTypes = {
    image: 'img',
    createdAt: 'date',
  };
  constructor(
    private billServiceReport: BillServiceReportService,
    private billServiceDelete: BillerDeleteBillerServiceService,
    route: Router,
    cdr: ChangeDetectorRef,
    activeRoute: ActivatedRoute
  ) {
    super(billServiceReport, billServiceDelete, route, cdr, activeRoute);
    this.setDisplayMessage('Bill Service');
  }
}
